import { render, staticRenderFns } from "./BeansConfiguration.vue?vue&type=template&id=472f2459&scoped=true"
import script from "./BeansConfiguration.vue?vue&type=script&lang=js"
export * from "./BeansConfiguration.vue?vue&type=script&lang=js"
import style0 from "./BeansConfiguration.vue?vue&type=style&index=0&id=472f2459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f2459",
  null
  
)

export default component.exports